import { useState } from "react"
import { UserRound } from "lucide-react"
import { Button } from "@/components/ui/button"
import { UserCombobox, type UserOption } from "@/components/user-combobox"
import { previewPrompt } from "@/lib/api"

export function MemberPreview() {
  const [member, setMember] = useState<UserOption | null>(null)
  const [text, setText] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  async function load() {
    if (!member) return
    setLoading(true)
    setError(null)
    try {
      setText((await previewPrompt("chat", member.id)).text)
    } catch {
      setError("Could not build the preview for this member.")
      setText(null)
    } finally {
      setLoading(false)
    }
  }

  return (
    <details className="group rounded-lg border p-4">
      <summary className="flex cursor-pointer items-center gap-2 text-sm font-medium">
        <UserRound className="size-4 text-muted-foreground" aria-hidden="true" />
        Preview with a member's context
      </summary>
      <p className="mt-2 text-sm text-muted-foreground">
        Shows the system prompt with one member's profile filled in. Read only; nothing is saved.
      </p>
      <div className="mt-3 flex flex-wrap items-center gap-2">
        <UserCombobox value={member} onSelect={(next) => { setMember(next); setText(null) }} placeholder="Choose a member" className="w-72" />
        <Button size="sm" onClick={load} disabled={!member || loading}>{loading ? "Building" : "Build preview"}</Button>
      </div>
      {error && <p role="alert" className="mt-3 text-sm text-destructive">{error}</p>}
      {text && (
        <pre className="mt-3 max-h-[28rem] overflow-auto rounded-md bg-muted/50 p-3 font-mono text-xs whitespace-pre-wrap">{text}</pre>
      )}
    </details>
  )
}
